"use client"

import type React from "react"
import { useEffect, useState } from "react"

export function GSAPProvider({ children }: { children: React.ReactNode }) {
  const [gsapReady, setGsapReady] = useState(false)

  useEffect(() => {
    if (typeof window === "undefined") return

    // Check if GSAP is already loaded
    if ((window as any).gsap && (window as any).ScrollTrigger) {
      setGsapReady(true)
      return
    }

    const gsapScript = document.createElement("script")
    gsapScript.src = "https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.2/gsap.min.js"
    gsapScript.async = true

    const scrollTriggerScript = document.createElement("script")
    scrollTriggerScript.src = "https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.2/ScrollTrigger.min.js"
    scrollTriggerScript.async = true

    const onBothLoaded = () => {
      // Ensure both scripts are loaded and available on window
      if ((window as any).gsap && (window as any).ScrollTrigger) {
        setGsapReady(true)
      }
    }

    gsapScript.onload = onBothLoaded
    scrollTriggerScript.onload = onBothLoaded

    gsapScript.onerror = () => console.error("[v0] Failed to load GSAP")
    scrollTriggerScript.onerror = () => console.error("[v0] Failed to load ScrollTrigger")

    document.head.appendChild(gsapScript)
    document.head.appendChild(scrollTriggerScript)
  }, [])

  return <>{children}</>
}
